import { useEffect, useState, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from './firebaseConfig';

const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const CustomerDetail = lazy(() => import('./pages/CustomerDetail'));
const QRScanner = lazy(() => import('./pages/QRScanner'));
const Report = lazy(() => import('./pages/Report'));

function App() {
  const [user, setUser] = useState<any>(undefined);
  const [staffStore, setStaffStore] = useState<string>('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        try {
          const q = query(collection(db, 'staff'), where('email', '==', u.email));
          const snapshot = await getDocs(q);
          if (!snapshot.empty) {
  const staffData = snapshot.docs[0].data();
  console.log('staffData:', staffData);
  console.log('store:', staffData.store);
  setStaffStore(staffData.store || '');
} else {
  console.log('staff document not found for email:', u.email);
}

        } catch (e) {
          console.log('staff fetch error:', e);
        }
      } else {
        setStaffStore('');
      }
    });
    return unsubscribe;
  }, []);

  if (user === undefined) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>読み込み中...</div>;
  }

  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>読み込み中...</div>}>
        <Routes>
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
          <Route path="/" element={user ? <Dashboard staffStore={staffStore} /> : <Navigate to="/login" />} />
          <Route path="/customer/:uid" element={user ? <CustomerDetail /> : <Navigate to="/login" />} />
          <Route path="/scanner" element={user ? <QRScanner staffStore={staffStore} /> : <Navigate to="/login" />} />
          <Route path="/report" element={user ? <Report staffStore={staffStore} /> : <Navigate to="/login" />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
